import { render } from "./BaseButton.vue?vue&type=template&id=2bf0323c"
import script from "./BaseButton.vue?vue&type=script&lang=ts"
export * from "./BaseButton.vue?vue&type=script&lang=ts"
script.render = render

export default script